import classNames from 'classnames';
import React, { FC } from 'react';
import { Icon } from '../Icon';
import styles from './PlayIcon.module.scss';

type PlayIconProps = {
	size?: 'lg';
};

export const PlayIcon: FC<PlayIconProps> = ({ size }) => {
	return (
		<span
			className={classNames(styles.playIcon, 'playIcon d-inline-flex position-absolute top-50 start-50 translate-middle', {
				[styles[`playIcon--${size}`]]: size,
			})}
		>
			<Icon.PlayCircle size={size === 'lg' ? 'xxl' : 'sm'} color="white" />
		</span>
	);
};
